<template>
  <div class="ui-block">
    <div class="ui-block-title">
      <h6 class="title">
        Ganduri
      </h6>
      {{ date1 | formatDate('MMM dd yyyy') }}
      <add-daily-answers />
      <edit-daily-answers />
      <div class="control-block-button">
        <a
          v-if="answ.length === 0"
          href="#"
          class="btn btn-control bg-breez"
          @click="$modal.show('create-daily-answers', { date: date1 })"
        >
          <app-icon
            name="olymp-plus-icon"
            color="white"
            size="normal"
          />
        </a>
      </div>
    </div>

    <div class="ui-block-content">
      <!-- W-Personal-Info-->
      <ul
        v-if="answ && answ.length"
        class="widget w-personal-info item-block"
      >
        <li
          v-for="(a, index) in answ"
          :key="index"
        >
          <span class="title">Cum a fost ziua de azi?</span>
          <a
            href="#"
            style="margin-left: 15px;"
            @click="$modal.show('edit-daily-answers', { id: a.id, description: a.description })"
          >
            <app-icon
              name="olymp-three-dots-icon"
              color="gray"
              size="normal"
            />
          </a>
          <!-- eslint-disable vue/no-v-html -->
          <span
            class="text"
            v-html="a.description"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AddDailyAnswers from './AddDailyAnswers'
import EditDailyAnswers from './EditDailyAnswers'
import { EventBus } from '../../../event-bus'
import AppIcon from "../../common-apps/common/AppIcon"
import dailyAnswersStore from "../../../store/modules/personal/daily-answers.js";

export default {
  name: 'TodayQuestions',
  components: { AddDailyAnswers, EditDailyAnswers, AppIcon },
  props: {
    date: {
      type: Date,
      default: function () { return {} }
    }
  },
  data () {
    return {
      date1: new Date(this.date)
    }
  },
  computed: mapState({
    answ: state => state.dailyAnswers ? state.dailyAnswers.answ : []
  }),
  activated () {
    this.date1 = new Date(this.date)
    if (!this.$store.hasModule('dailyAnswers')) {
      this.$store.registerModule('dailyAnswers', dailyAnswersStore)
    }
    this.$store.dispatch('dailyAnswers/getToday', { date1: this.date1 })

    EventBus.$on('changed-month-day', (date2) => {
      // eslint-disable-next-line
        this.date1 = date2;
      this.$store.dispatch('dailyAnswers/getToday', { date1: this.date1 })
    })
  },
  beforeDestroy () {
    this.$store.unregisterModule('dailyAnswers')
  },
}
</script>

<style lang="scss" scoped>
  .vdp-datepicker {
    padding: 0 15px;
  }

</style>
